import Modals from "../modules/modals";
var nanobus = require('nanobus');
export var initAdminColumnsGlobalBootstrap = function () {
    if (!window.AdminColumns) {
        window.AdminColumns = window.AdminColumns || {};
        AdminColumns.events = nanobus();
        AdminColumns.Modals = new Modals();
    }
    return window.AdminColumns;
};
